import React, { useEffect, useTransition } from "react";
import { useNavigate } from "react-router-dom";
import { setAuthenticate } from "../api";
import { useForm } from "react-hook-form";
import { Container, Row } from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { loginAction } from "../redux/actions/auth.action";
import Alert from "../components/Alert";
import CustomInout from "./form/CustomInput/Index";
import "../style/login.css"
import { Col } from "react-bootstrap";
import { automationTokenSet } from "api/automation.api";
// form validation rules
const validationSchema = Yup.object().shape({
  email: Yup.string().required("Email is required").email("Please enter a valid email"),
  password: Yup.string().required("Password is required")
    .min(6, "Password must be at least 6 characters")

});
const formOptions = { resolver: yupResolver(validationSchema) };

const Login = () => {
  const dispatch = useDispatch();
  const { message } = useSelector((state) => state.auth);
  let navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { register, handleSubmit, reset, formState } = useForm(formOptions);
  const { errors, isSubmitting } = formState;
  useEffect(() => {
    if (user) {
      const data = JSON.parse(atob(user.tokens.split(".")[1]));
      const isValidToken = data.exp * 1000 > new Date();
      if (isValidToken) {
        setAuthenticate(user.tokens);
        automationTokenSet(user.tokens)
        navigate("/profile");
      }
    }
    else {
      const remembered = localStorage.getItem("rememberedUser");
      if (remembered) {
        const { email, password } = JSON.parse(remembered);
        console.log("asas")
        reset({ email, password, remember: true });
      }
    }

  }, []);

  async function onSubmit(data) {
    // if (data.remember) {
    //   localStorage.setItem("rememberedUser", JSON.stringify({ email: data.email, password: data.password }))
    // }
    dispatch(
      loginAction(
        {
          email: data.email,
          password: data.password,
          remember: data.remember
        },
        navigate
      )
    );
  }

  return (
    <div className="bg-white">
      <Container fluid>
        <Row className="h-100">
          <Col className="d-none d-md-block" md={7} lg={7} >
            <div className="vh-100  h-100 w-100 " >
              <img alt="" style={{
                width: "100%",
                height: "100%"
              }} src="../assets/DMD Login Page 984x888.jpg" />
            </div>
          </Col>
          <Col sm={12} md={5} lg={5}>
            <div className="vh-100  contain74">
              <div className="login-card-component ">
                <img
                  alt="profile-img"
                  className="profile-img-card"
                  src="../assets/Logo.png"
                />
                {/* <p className="login-text">Login</p> */}

                <form onSubmit={handleSubmit(onSubmit)} className="login-form">
                  <CustomInout
                    disabled={isSubmitting}
                    type="email"
                    {...register("email")}
                    label="Email Address *"
                    error={errors.email?.message}
                  />
                  <CustomInout
                    disabled={isSubmitting}
                    type="password"
                    {...register("password")}
                    label="Password *"
                    error={errors.password?.message}
                  />
                  <label className="remember-me-label">
                    <input type="checkbox" {...register("remember")} disabled={isSubmitting} />
                    Remember me
                  </label>
                  {message && (
                    <div className="form-group">
                      <Alert
                        className={
                          message === "success"
                            ? "alert alert-success"
                            : "alert alert-danger"
                        }
                        showAlert={true}
                        message={message}
                      />
                    </div>
                  )}

                  <button type="submit" className={`login-btn-custom ${isSubmitting && 'disabled'}`} disabled={isSubmitting}>
                    {isSubmitting && (
                      <span className="spinner-border spinner-border-sm"></span>
                    )}
                    Login
                  </button>

                </form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>



  );
};
export default Login;
